/** Vários endereços no mesmo campo podem vir separados por `;`, `,` ou espaço. */
const EMAIL_SEPARATORS = /[;,\s]+/;

/** Parte local e domínio codificadas à parte, para o `@` do endereço seguir como separador. */
function encodeAddress(address: string): string {
  const at = address.lastIndexOf("@");

  return `${encodeURIComponent(address.slice(0, at))}@${encodeURIComponent(address.slice(at + 1))}`;
}

/**
 * Destino do e-mail: nova mensagem com os endereços como destinatários. O `mailto:` delega ao cliente de e-mail padrão
 * (Outlook nas estações do Hub). Espaços ao redor são descartados e vários endereços viram uma lista separada por
 * vírgula; sem nenhum endereço (nada com `@`), não há link. Cada endereço é codificado (RFC 6068) para que `?` ou `&`
 * no valor da fonte não virem cabeçalho (cc, bcc, subject, body) da mensagem.
 */
export function buildMailtoHref(email: string): string | undefined {
  const recipients = email
    .split(EMAIL_SEPARATORS)
    .map((address) => address.trim())
    .filter((address) => address.includes("@"));

  if (recipients.length === 0) return undefined;

  return `mailto:${recipients.map(encodeAddress).join(",")}`;
}
